import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { Button, LoadingSpinner, Modal } from "../../../components";
import HelperNumber from "../../../helpers/HelperNumber";
import "./styles.scss";
import CategoryItem from "../../../components/SupportingMaterial/CategoryItem";
import SupportingMaterialService from "../../../services/SupportingMaterialService";

const SupportingMaterial = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const [banner, setBanner] = useState<string | null>(null);
    const [isLoad, setIsLoad] = useState<Boolean>(false);
    const [category, setCategory] = useState<any>(null);
    const getCategory = async () => {
            setIsLoad(true);
         SupportingMaterialService.getCategory()
            .then((response: any) => {
                if (response) { setCategory(response); }
                setIsLoad(false);
            }).catch((error: any) => {setIsLoad(false); });
    }
    const getBanner = async () => {
            setIsLoad(true);
         SupportingMaterialService.getBanner()
            .then((response: any) => {
                if (response) { setBanner(response.url); }
                setIsLoad(false);
            }).catch((error: any) => {setIsLoad(false); });
    }

    useEffect(() => {
        getBanner();
        getCategory();
    }, []);

    const categories = [
        { name: "EZE SOLAR", content: "Conteúdo 1",isHighlight: false },
        { name: "OUTRA EMPRESA", content: "Conteúdo 2", isHighlight:true },
        { name: "TERCEIRA EMPRESA", content: "Conteúdo 3", isHighlight:false }
    ];
    const handleToggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
        {
            isLoad === true &&
            <LoadingSpinner />
        }
            <div style={{ maxWidth: 600, margin: "0 auto" }}>
                {
                    banner &&
                        <img src={banner??undefined} alt="" style={{width:'100%', maxWidth:600, marginBottom:15}} />
                }
                {
                    (category) &&
                    category
                    .sort((a:any, b:any) => a.ordem - b.ordem)
                    .map((cat:any, index:number) => (
                        <CategoryItem
                            key={index}
                            cat={cat}
                            isHighlight={cat.isHighlight}
                            isOpen={openIndex === index}
                            onClick={() => handleToggle(index)}
                        />
                    ))
                }
            </div>
        </>
    );
};

export default SupportingMaterial;